import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-1.5,-2h2.5v0.5h-2.5zM2,-1h1.5v0.5h-1.5zM-2.5,-0.5h1v0.5h-1zM1,-0.5h3.5v1h-3.5zM-3,0h0.5v0.5h-0.5zM-2,0h1v0.5h-1zM-2.5,0.5h1.5v0.5h-1.5zM0,0.5h2v0.5h-2zM3,0.5h1v0.5h-1zM-2,1h0.5v0.5h-0.5zM0.5,1h1v0.5h-1z',
    },
    {
      paint: [
        ['cart', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-3h1v0.5h-1zM-2.5,-2.5h1v0.5h-1zM-0.5,-2.5h2v0.5h-2zM1,-2h0.5v0.5h-0.5zM-2,-1.5h0.5v0.5h-0.5zM-2.5,-1h1.5v0.5h-1.5zM-0.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'cart',
      d: 'M-3,-2h1v1h-1zM-1.5,-1.5h1.5v0.5h-1.5zM-3,-1h0.5v0.5h-0.5zM-1,-1h1v0.5h-1zM-1,-0.5h0.5v0.5h-0.5zM-0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['cart', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-1.5,-2.5h1v0.5h-1zM-2,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h2v1h-2zM-1.5,-0.5h0.5v0.5h-0.5zM0.5,-0.5h0.5v0.5h-0.5zM0,0h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M-2.5,0h0.5v0.5h-0.5zM0.5,0h0.5v0.5h-0.5z' },
  ],
  pixels: 83,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
